module.exports = __webpack_public_path__ + "static/media/customer_users.f9dd701e.svg";